import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { enableDlcForm } from 'redux/actions';
import { useStyles } from './styles';

const SaveModal = ({ show, handleShowScheduleMessageModal, handleShowSaveModal }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(show);

  const handleClose = () => {
    setOpen(false);
    handleShowSaveModal(false);
    handleShowScheduleMessageModal(false);
    dispatch(enableDlcForm(false));
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.title} id="alert-dialog-title">
          {t('save_for_later', 'Save for later')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t(
              'save_modal_description',
              'Your response has been saved successfully. To complete the form, you can revisit from',
            )}{' '}
            <span className={classes.boldText}>
              {t('profile_dropdown', 'Profile Dropdown')} {'>'} {t('ten_dlc', '10DLC Registration')}
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" data-testid="ok-button" autoFocus>
            {t('ok_text', 'OK')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

SaveModal.propTypes = {
  show: PropTypes.bool,
  handleShowScheduleMessageModal: PropTypes.func,
  handleShowSaveModal: PropTypes.func,
};

export default SaveModal;
